import useValidation from "../../hooks/useValidation"
import { useEffect } from "react"
import { LeaderChangeType } from "../../static/types/commonTypes/leaderChangeType"
import leaderChangeValidationSchema from "../../utils/validation/leaderChangeValidationSchema"
import { useDraftManager } from "../../hooks/useDraftManager"

type LeaderChangePropType = {
    checked: boolean,
    leaderChange: LeaderChangeType,
    changes: string[],
    functions: string[],
    updateLeaderChange: ( partialLeaderChange: Partial<LeaderChangeType> ) => void,
    onValidationChange: ( isValid: boolean ) => void
}

export default function LeaderChange ({
    checked,
    leaderChange,
    changes,
    functions,
    updateLeaderChange,
    onValidationChange
}: LeaderChangePropType ) {

    const { errors, isValid } = useValidation( leaderChange, leaderChangeValidationSchema )

    const { pushDraftContent} = useDraftManager()

    useEffect( () => {
        onValidationChange( isValid )

        pushDraftContent({ leaderChange })
    }, [ isValid, onValidationChange ])

    useEffect(() => {
        if( !leaderChange.change ) updateLeaderChange({ change: changes[0] || '' })
    }, [])

    return(
        <div className = "mb-3 row">

            <div className = "mb-3 row">

                <label htmlFor = "change" className = "col-sm-2 col-form-label"> Modification <strong className="text-danger">*</strong>  </label>

                <div className = "col-sm-10">

                    <select
                        className = { `form-select ${ ( checked && errors.change ) ? 'is-invalid' : ''}` }
                        name = "change"
                        id = "change"
                        value = { leaderChange.change }
                        onChange = { event => updateLeaderChange({ change: event.target.value } )}
                    >
                        {
                            changes.map( option => 
                                <option key = { option } value = {option}>
                                    {option}
                                </option>
                            )
                        }

                    </select>
                    {( checked && errors.change ) && <div className="invalid-feedback"> { errors.change } </div> }

                </div>

            </div>

            <div className = "mb-3 row">

                <label htmlFor = "function" className = "col-sm-2 col-form-label"> Fonction <strong className="text-danger">*</strong>  </label>

                <div className = "col-sm-10">

                    <select
                        className = { `form-select ${ ( checked && errors.function ) ? 'is-invalid' : ''}` }
                        name = "function"
                        id = "function"
                        value = { leaderChange.function }
                        onChange = { event => updateLeaderChange({ function: event.target.value } )}
                    >
                        {
                            functions.map( option => 
                                <option key = { option } value = {option}>
                                    {option}
                                </option>
                            )
                        }

                    </select>
                    {( checked && errors.function ) && <div className="invalid-feedback"> { errors.function } </div> }

                </div>

            </div>

        </div>
    )
}